import React, { useEffect, useState } from "react";
import Select from "react-select";
import {
  REACT_APP_VAM_CONTEXT_INGESTION,
  REACT_APP_VAM_CONTEXT_SURVEYOR,
  REACT_APP_VAM_CONTEXT_LITIGATION,
  REACT_APP_VAM_CONTEXT_VENDOR,
  REACT_APP_VAM_ENDPOINT,
  REACT_APP_VAM_CONTEXT_ROLE_MANAGMENT,
  WRAPPER_SERVICE,
} from "../urls";
import { toast } from "react-toastify";
import { REACT_APP_KSHEMA_POC2 } from "../urls";
import {
  editModeOn,
  firstLetterCapital,
  generateYears,
  getFromDecreaptLocalStorage,
  titleCase,
} from "../utilFunctions";
import { Col } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { useNavigate } from "react-router-dom";
import "../scss/claimCalculation.scss";
import { axiosClient, axiosRequest } from "../service";
import { functionalities, METHOD, PAGE_NAME_KEYS,GOVT_PRODUCT, PMFBY, KISAN_SATHI, claimPendindActions, policyStatus} from "../consts";
import { getCalamityNames, getClaimsCreatedByList, getPerilList } from "../dashboard/apiHelper";
import { getVendorsList } from "../dashboard/vendorMaster/helper";
import AsteriskSymbol from "../reusableComponents/AsteriskSymbol";
import CustomProductSelect from "./CustomProductSelect";
import CustomMultiSelect from "../reusableComponents/CustomMultiSelect";
import { fetchFlaggedClaimsOptions } from "../dashboard/claimLitigation/litigationApi";

const AdvanceSearch = (props) => {
  const {
    claimWithoutPolicyPage,
    setClaimWithoutPolicyPage,
    showAdvanceSearch,
    cropList,
    setCropList,
    perilList,
    setPerilList,
    setList,
    searchFields,
    selectedPage,
    itemsPerPage,
    triggerAPi,
    navigateToMasterCreation,
    productNames,
    setsearchFields,
    setShowAdvanceSearch,
    setProductID,
    productID,
    setSearchResultMode,
    module,
    loading,
    setLoading,
    defaultSearch,
    resetFields,
    setSelectedPage,
    setItemsPerPage,
    setPageCount,
    list,
    setResetPagination,
    resetPagination,
    setTotalRecords,
    handleScroll,
    selectedProducts, // for claim processing screen
    setSelectedProducts // for claim processing screen
  } = props;
  const [statesList, setStatesList] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  const [mandalList, setMandalList] = useState([]);
  const [villageList, setVillageList] = useState([]);
  const [pincodeList, setPincodeList] = useState([]);
  const [caimRoles, setClaimRoles] = useState([]);
  const [assignedTos, setAssignedTos] = useState([]);
  const [claimStatus, setClaimStatus] = useState([]);
  const [claimSubStatus, setClaimSubStatus] = useState([]);
  const cmsStatusListCookies = getFromDecreaptLocalStorage("CMSstatusList");
  const [subStatusCount, setSubStatusCount] = useState(null);
  const [selectedSubStatus, setSelectedSubstatus] = useState(null);
  const [perilOptions, setPerilOptions] = useState([]);
  const [cropOptions, setCropOptions] = useState([]);
  const [calamityTypes, setCalamityTypes] = useState([]);
  const [vendorList, setVendorList] = useState([]);
  const [surveyorList, setSurveyorList] = useState([]);
  const [vendorId, setVendorId] = useState([]);
  const [isViewMore, setIsViewMore] = useState(false);
  const [policyStatusOptions, setPolicyStatusOptions] = useState("");
  const [productName, setProductName] = useState("");
  const [emailName, setEmailName] = useState([]);
  const [createdByList, setCreatedByList] = useState([]);
  const isGovtProduct =
  module === "claim_processing"
    ? GOVT_PRODUCT.includes(productName?.toUpperCase())
    : GOVT_PRODUCT.includes(searchFields.product_name?.label?.toUpperCase());
  const [noOptionPlaceholder, setNoOptionPlaceHolder] = useState(
    "minimum 3 characters required"
  );
  const [assigneeOptions, setAssigneeOptions] = useState([]);
  const[flaggedClaimsOptions, setFlaggedClaimsOptions] = useState([])
  // Create the years array dynamically from 2010 to the current year

  const navigate = useNavigate();

  const yearsFrom2010 = generateYears(2010);

  const claimIngestionTypes = [
    { id: 1, label: "Individual", value: "Individual" },
    { id: 2, label: "Area Based", value: "Area Based" },
  ];
  const searchTypes = [
    { label: "Policy ID", value: 1 },
    { label: "Mobile Number", value: 2 },
    { label: "Farmer ID", value: 3 },
    { label: "Bank Account Number", value: 4 },
    { label: "Advance Search", value: 5 },
  ];
  const seasonValues = [
    { label: "Rabi", value: "Rabi" },
    { label: "Kharif", value: "Kharif" },
  ];


  useEffect(() => {
    if (
      !(
        searchFields.assignedTo == "" &&
        searchFields.role == "" &&
        searchFields.claimStatus == "" &&
        searchFields.claimSubStatus == "" &&
        searchFields.claimID == "" &&
        searchFields.policyID == "" &&
        searchFields.mobileNo == "" &&
        searchFields.farmerID == "" &&
        searchFields.pendingActions == "" &&
        searchFields.productName == "" &&
        searchFields.state == "" &&
        searchFields.district == "" &&
        searchFields.mandal == "" &&
        searchFields.village == "" &&
        searchFields.fromDate == "" &&
        searchFields.toDate == "" &&
        searchFields.seasonName == "" &&
        searchFields.seasonYear == "" &&
        searchFields.claimIngestionType == "" &&
        searchFields.peril == "" &&
        searchFields.crop == "" &&
        searchFields.calamityType == "" &&
        searchFields.policyStatus == "" &&
        searchFields.vendorName == "" &&
        searchFields.surveyorName == "" &&
        searchFields.assignedTeamMemberId == "" &&
        searchFields.email == "" &&
        searchFields.isAttachmentAvailable == "" &&
        searchFields.selectedFlags?.length == 0 &&
        searchFields.createdBy === ""
      ) &&
      module == "claim_processing"
    ) {
      basicSearch();
    }
    if (searchFields.claimSubStatus !== null) {
      setSelectedSubstatus(searchFields.claimSubStatus);
    }
  }, [triggerAPi]);

  useEffect(() => {
    if (productName !== "") {
      getPerilList(productName, setPerilOptions)
      getCropsList(productName)
    }
  }, [productName]);

  const getEmailName = (value) => {
    // Email API is expecting 3 characters
    if (value.length >= 3) {
      axiosClient(
        `${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_ROLE_MANAGMENT}`
      )({
        url: "email/search",
        method: METHOD.GET,
        params: { searchKey: value },
      })
        .then((data) => {
          if (data.data.length > 0)
            setEmailName(
              data.data.map((option) => ({ label: option, value: option }))
            );
          else setNoOptionPlaceHolder("Search results not found");
        })
        .catch((e) => {
          console.error(e);
        });
    } else if (value.length > 0) {
      setEmailName([]);
      setNoOptionPlaceHolder("Minimum 3 characters required");
    }
  };
  const getClaimSearchfields = () => {
    axiosClient(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_INGESTION}`)(
      {
        url: "getClaimAssigned",
        method: METHOD.GET,
      }
    )
      .then((data) => {
        const assigned = data.data;
        // Sort products by productName (label) alphabetically
        assigned && assigned.sort((a, b) => a - b);
        // Map products to label-value pairs
        const sortedAssigned = assigned
          .filter(
            (product) =>
              product !== null && product !== undefined && product !== ""
          ) // Filter out null and undefined values
          .map((product) => {
            return {
              label: product,
              value: product,
            };
          });

        setAssignedTos(sortedAssigned);
      })
      .catch((error) => {
        console.error(error);
      });
    axiosClient(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_INGESTION}`)(
      { url: "getClaimRoles", method: METHOD.GET }
    )
      .then((data) => {
        const filteredData = data.data.filter(
          (list) => list !== null && list !== ""
        );
        setClaimRoles(
          filteredData.map((list) => {
            return {
              label: list,
              value: list,
            };
          })
        );
      })
      .catch((error) => {
        console.error(error);
      });
    axiosClient(
      `${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_LITIGATION}`
    )({ url: "team", method: METHOD.GET })
      .then((data) => {
        setAssigneeOptions(
          data.data.map((option) => {
            return {
              id: option.id,
              label: option.assignedTeam,
              value: option.assignedTeam,
            };
          })
        );
      })
      .catch((e) => console.error(e));
    axiosClient(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_INGESTION}`)(
      { url: "getClaimStatus", method: METHOD.GET }
    )
      .then((data) => {
        const filteredData = data.data.filter(
          (list) => list !== null && list !== ""
        );
        setClaimStatus(
          filteredData.map((list) => {
            return {
              label: list,
              value: list,
            };
          })
        );
      })
      .catch((error) => {
        console.error(error);
      });
    axiosClient(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_INGESTION}`)(
      { url: "getClaimSubStatus", method: METHOD.GET }
    )
      .then((data) => {
        const filteredData = data.data.filter(
          (list) => list && list !== "null"
        );
        setClaimSubStatus(
          filteredData.map((list) => {
            return {
              label: list,
              value: list,
            };
          })
        );
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const getSubStatusCount = (selectedValue) => {
    if (selectedValue !== null) {
      axiosClient(
        `${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_INGESTION}`
      )({
        url: "substatus/count",
        method: METHOD.GET,
        params: { claimSubStatus: selectedValue },
      })
        .then((data) => {
          setSubStatusCount(data.data.substatusCount);
        })
        .catch((error) => {
          console.error(error);
        });
    } else {
      console.error("Invalid selected value");
    }
  };

  // useEffect(() => {
  //     if(selectedSubStatus !== null){
  //         getSubStatusCount();
  //     }

  // }, [selectedSubStatus])

  useEffect(() => {
    if (module === "claim_processing") {
      getClaimSearchfields();
    }
    getStatesList();
    getCropOptions();
    getPolicyStatusOptions();
    getVendorsList(setVendorList);
    getCalamityNames({ setCalamityTypes} );
    getClaimsCreatedByList({setCreatedByList});
  }, []);
  useEffect(() => {
    getCalamityNames({ setCalamityTypes }, searchFields?.claimIngestionType);
  }, [searchFields?.claimIngestionType])


  const sortStatesAlphabetically = (states) => {
    return [...states].sort((a, b) => a.localeCompare(b));
  };

  const getSurveyorList = () => {
    axiosRequest()
      .get(
        `${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_SURVEYOR}/getSurveyorAndQCMasterList`,{ params: {stateForAllocationDetails:null,vendorId:vendorId,districtForAllocationDetails:null }}
      )
      .then((data) => {
        setSurveyorList(
          data.data.map((list) => {
            const fullName = list.lastName
              ? `${list.firstName} ${list.lastName}`
              : list.firstName;
            return {
              label: `${fullName} (${list.mobileNumber})`,
              value: `${fullName}`,
            };
          })
        );
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const getStatesList = () => {
    axiosRequest()
      .get(`${WRAPPER_SERVICE}/states`)
      .then((response) => {
        const states = response.data.States.flat(Infinity);
        const sortedStates = sortStatesAlphabetically(states);
        const mappedStates = sortedStates.map((state) => ({
          label: state,
          value: state,
        }));
        setStatesList(mappedStates);
      })
      .catch((error) => {
        console.error("Error fetching states:", error);
      });
  };
  const getDiscrictList = (state) => {
    axiosRequest()
      .get(`${WRAPPER_SERVICE}/districts/${state}`)
      .then((data) => {
        setDistrictList(
          data.data.Districts.flat("Infinity").map((list) => {
            return {
              label: list,
              value: list,
            };
          })
        );
      })
      .catch((error) => {
        console.error(error);
      });
  };
  const getPolicyStatusOptions = () => {
    axiosRequest()
      .get(`${REACT_APP_KSHEMA_POC2}/government-status`)
      .then((data) => {
        const policyData = data.data.status.flat("Infinity").map((list) => {
          return {
            label: titleCase(list),
            value: titleCase(list),
          };
        });
        setPolicyStatusOptions([...policyStatus, ...policyData]);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const handleIntimationDateRange = (date, key) => {
    if (date) {
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const dat1 = date.getDate().toString().padStart(2, "0");
      setsearchFields({ ...searchFields, [key]: `${year}-${month}-${dat1}` });
    }
  };
  const getCropOptions = () => {
    axiosRequest()
      .get(`${WRAPPER_SERVICE}/crops/product/Kshema Sukriti`)
      .then((data) => {
        setCropOptions(
          data.data.crops.map((list) => {
            return {
              label: list.cropName,
              value: list.cropName,
            };
          })
        );
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const getMandalList = (district) => {
    axiosRequest()
      .get(`${WRAPPER_SERVICE}/mandals/${searchFields.state}/${district}`)
      .then((data) => {
        setMandalList(
          data.data.Mandal.flat("Infinity").map((list) => {
            return {
              label: list,
              value: list,
            };
          })
        );
      })
      .catch((error) => {
        console.error(error);
      });
  };
  const getVillageList = (mandal) => {
    axiosRequest()
      .get(
        `${WRAPPER_SERVICE}/villages/${searchFields.state}/${searchFields.district}/${mandal}`
      )
      .then((data) => {
        setVillageList(
          data.data.Villages.flat("Infinity").map((list) => {
            return {
              label: list,
              value: list,
            };
          })
        );
      })
      .catch((error) => {
        console.error(error);
      });
  };
  const getPincodeList = (village) => {
    axiosRequest()
      .get(
        `${WRAPPER_SERVICE}/pincode/${searchFields.state}/${searchFields.district}/${searchFields.mandal}/${village}`
      )
      .then((data) => {
        setsearchFields({
          ...searchFields,
          village: village,
          pincode: data.data.Pincode,
        });
        setPincodeList(
          data.data.Pincode.flat("Infinity").map((list) => {
            return {
              label: list,
              value: list,
            };
          })
        );
      })
      .catch((error) => {
        console.error(error);
      });
  };
  const getCropsList = (product_name) => {
    const baseURL= product_name== PMFBY ? `${REACT_APP_KSHEMA_POC2}/crop-master` : `${WRAPPER_SERVICE}/crops/product`
    axiosRequest()
      .get(`${baseURL}/${product_name}`)
      .then((data) => {
        setCropList(
          data?.data?.crops?.map((list) => {
            return {
              label: list.cropName,
              value: list.pmfbyCid,
            };
          })
        );
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const handleVendorChange = (data) => {
    setVendorId(data?.id || "");
  };
  useEffect(() => {
    if (vendorId.length !== 0) getSurveyorList();
  }, [vendorId]);
  useEffect(() => {
    async function loadFlagOptions() {
      try {
        const data = await fetchFlaggedClaimsOptions(setLoading)
        const options = (Array.isArray(data) ? data : [])
          .filter(item => item.isActive) 
          .map(item => ({
            label: item.flagName,
            value: item.flagId,   
            flagId: item.flagId,   
          }));
        setFlaggedClaimsOptions(options);
      } catch (err) {
        console.error("Error fetching flagged claims:", err);
      }
    }
    loadFlagOptions();
  }, []);

  const basicSearch = (buttonClick) => {
    if (module === "claim_intimation") {
      if (!searchFields.product_name) {
        toast.error("Please Select Product Name");
        return;
      }
      if (!searchFields.search_type.value) {
        toast.error("Please Select Search Type");
        return;
      }
      if (!searchFields.search_type_value) {
        toast.error(`Please Enter ${searchFields.search_type.label}`);
        return;
      }
      if (
        searchFields.search_type.value == 2 &&
        searchFields.search_type_value.length !== 10
      ) {
        toast.error("Mobile number should be 10 digit");
        return;
      }
    } else if (module === "claim_processing") {
      if (
        searchFields.assignedTo == "" &&
        searchFields.role == "" &&
        searchFields.seasonName == "" &&
        searchFields.seasonYear == "" &&
        searchFields.claimStatus == "" &&
        searchFields.toDate == "" &&
        searchFields.fromDate == "" &&
        searchFields.claimSubStatus == "" &&
        searchFields.claimID == "" &&
        searchFields.policyID == "" &&
        searchFields.mobileNo == "" &&
        searchFields.farmerID == "" &&
        searchFields.pendingActions == "" &&
        searchFields.productName == "" &&
        searchFields.state == "" &&
        searchFields.district == "" &&
        searchFields.mandal == "" &&
        searchFields.village == "" &&
        searchFields.claimIngestionType == "" &&
        searchFields.peril == "" &&
        searchFields.crop == "" &&
        searchFields.calamityType == "" &&
        searchFields.policyStatus == "" &&
        searchFields.vendorName == "" &&
        searchFields.surveyorName == "" &&
        searchFields.assignedTeamMemberId == "" &&
        searchFields.email == "" &&
        searchFields.isAttachmentAvailable == "" &&
        searchFields.selectedFlags?.length == 0 &&
        searchFields.createdBy === ""
      ) {
        toast.error("Please Input a search Parameter");
        return;
      }
    } else if (module === "vendor_master") {
      if (
        searchFields.vendorId == "" &&
        searchFields.vendorName == "" &&
        searchFields.mobileNumber == "" &&
        searchFields.email == "" &&
        searchFields.state == "" &&
        searchFields.district == "" &&
        searchFields.status == ""
      ) {
        toast.error("Please Input a search Parameter");
        return;
      }
    } else if (module === "surveyor_master") {
      if (
        searchFields.surveyorId == "" &&
        searchFields.firstName == "" &&
        searchFields.lastName == "" &&
        searchFields.mobileNumber == "" &&
        searchFields.email == "" &&
        searchFields.state == "" &&
        searchFields.district == "" &&
        searchFields.status == ""
      ) {
        toast.error("Please Input a search Parameter");
        return;
      }
    }
    setLoading(true);
    switch (module) {
      case "claim_intimation":
        axiosRequest()
          .post(`${WRAPPER_SERVICE}/search`, {
            searchType: String(searchFields.search_type.value),
            product: searchFields.product_name.label,
            searchValue: searchFields.search_type_value,
          })
          .then((data) => {
            setLoading(false);
            data?.data && !data.data.includes("No Data Present")
              ? setList(data.data)
              : setList([]);
            setSearchResultMode(true);
          })
          .catch((error) => {
            console.error(error);
          });
        break;
      case "claim_processing":
        axiosRequest()
          .post(
            `${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_INGESTION}/details`,
            {
              assignedTo: searchFields.assignedTo,
              role: searchFields.role,
              claimStatus: searchFields.claimStatus,
              claimSubStatus: searchFields.claimSubStatus,
              claimID: searchFields.claimID,
              policyID: searchFields.policyID,
              mobileNo: searchFields.mobileNo,
              alternateMobileNo: searchFields.alternateMobileNo,
              farmerID: searchFields.farmerID,
              pendingActions: searchFields.pendingActions,
              productName: 0,
              multipleProductNames: selectedProducts?.length ? selectedProducts?.map(product => product?.value): null,
              state: searchFields.state,
              district: searchFields.district,
              mandal: searchFields.mandal,
              village: searchFields.village,
              claimIngestionType: searchFields.claimIngestionType.id
                ? searchFields.claimIngestionType.id
                : 0,
              calamityType: searchFields.calamityType.id
                ? searchFields.calamityType.id
                : 0,
              policyStatus: searchFields.policyStatus
                ? searchFields.policyStatus
                : "",
              seasonName: searchFields.seasonName
                ? searchFields.seasonName
                : "",
              seasonYear: searchFields.seasonYear
                ? searchFields.seasonYear
                : "",
              crop: searchFields.crop ? searchFields.crop : "",
              peril: searchFields.peril ? searchFields.peril : "",
              fromDate: searchFields.fromDate
                ? searchFields.fromDate + "T00:00:00.000"
                : "",
              toDate: searchFields.toDate
                ? searchFields.toDate + "T23:59:59.999"
                : "",
              vendorName: searchFields.vendorName.label
                ? searchFields.vendorName.label.split("(")[0].trim()
                : "",
              surveyorName: searchFields.surveyorName
                ? searchFields.surveyorName
                : "",
              assignedTeamMemberId: searchFields.assignedTeamMemberId
                ? searchFields.assignedTeamMemberId?.id
                : 0,
              email: searchFields.email ? searchFields.email : "",
              isAttachmentAvailable: searchFields.isAttachmentAvailable
                ? searchFields.isAttachmentAvailable
                : "",
              selectedFlags : Array.isArray(searchFields?.selectedFlags) ? searchFields.selectedFlags: [],
              createdBy: searchFields.createdBy.value ? searchFields.createdBy.value : "",
              pageNo: buttonClick ? 1 : selectedPage,
              count: buttonClick ? 10 : itemsPerPage,
            }
          )
          .then((data) => {
            const claimIntimationLists = { ...data.data };
            // sortClaimResultsOnIntimationDate(claimIntimationLists.claimDetailDTOs)
            setPageCount(claimIntimationLists.totalPages);
            setSelectedPage(claimIntimationLists.currentPage);
            setItemsPerPage(claimIntimationLists.pageSize);
            setTotalRecords(claimIntimationLists.totalRecords);
            setSearchResultMode(true);
            setLoading(false);
            data?.data && data.data !== "No Data Present"
              ? setList(data.data.claimDetailDTOs)
              : setList([]);
          })
          .catch((error) => {
            console.error(error);
            setLoading(false);
          });
        break;
      case "vendor_master":
        axiosRequest()
          .post(
            `${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_VENDOR}/searchVendorMaster`,
            { ...searchFields, status: searchFields.status.label }
          )
          .then((data) => {
            setResetPagination(!resetPagination);
            setList(data.data);
            setSearchResultMode(true);
            setLoading(false);
          })
          .catch((error) => {
            console.error(error);
            setLoading(false);
          });
        break;
      case "surveyor_master":
        axiosRequest()
          .post(
            `${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_SURVEYOR}/searchSurveyorAndQCMaster`,
            { ...searchFields, status: searchFields.status.label }
          )
          .then((data) => {
            setResetPagination(!resetPagination);
            setList(data.data);
            setSearchResultMode(true);
            setLoading(false);
          })
          .catch((error) => {
            console.error(error);
            setLoading(false);
          });
        break;
      default:
      // code block
    }
  };
  const getClaimWithouPolicyPage = () => {
    setClaimWithoutPolicyPage(true);
  };
  const sortClaimResultsOnIntimationDate = (data) => {
    let sortedDates = [];
    sortedDates = data?.sort(function (a, b) {
      return new Date(b.createdDate) - new Date(a.createdDate);
    });
    sortedDates ? setList([...sortedDates]) : setList([]);
  };
  const advanceSearch = () => {
    if (!searchFields.product_name) {
      toast.error("Please Select Product Name");
      return;
    }
    if (!searchFields.state) {
      toast.error("Please Select State");
      return;
    }
    if (!searchFields.district) {
      toast.error("Please Select District");
      return;
    }
    if (!searchFields.mandal) {
      toast.error("Please Select Mandal");
      return;
    }
    if (!searchFields.village) {
      toast.error("Please Select Village");
      return;
    }
    switch (module) {
      case "claim_intimation":
        axiosRequest()
          .get(
            `${WRAPPER_SERVICE}/advance-search?product_name=${
              searchFields.product_name.label
            }&state=${searchFields.state}&district=${
              searchFields.district
            }&mandal=${searchFields.mandal}&village=${searchFields.village}${
              searchFields.pincode ? `&pincode=${searchFields.pincode}` : ""
            }${
              searchFields.farmer_name
                ? `&farmer_name=${searchFields.farmer_name}`
                : ""
            }${
              searchFields.crop?.label
                ? `&crop_name=${searchFields.crop?.label}`
                : ""
            }${
              searchFields.perilName
                ? `&perilName=${searchFields.perilName}`
                : ""
            }`
          )
          .then((data) => {
            data?.data && data.data !== "No Data Present"
              ? setList(data.data)
              : setList([]);
            setSearchResultMode(true);
          })
          .catch((error) => {
            console.error(error);
          });
        break;
      case "claim_processing":
        axiosRequest()
          .post(
            `${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_INGESTION}/details`,
            {
              state: searchFields.state,
              district: searchFields.district,
              mandal: searchFields.mandal,
              village: searchFields.village,
              pincode: searchFields.pincode,
              riskName: searchFields.crop.label,
              custmerName: searchFields.farmer_name,
              productID: productID,
              perilName: searchFields.perilName,
            }
          )
          .then((data) => {
            setList(data.data);
            // sortClaimResultsOnIntimationDate(data.data)
            setSearchResultMode(true);
          })
          .catch((error) => {
            console.error(error);
          });
        break;
      default:
      // code block
    }
  };

  const attachmentAvailabilityOptions = [
    { label: "Yes", value: "Yes" },
    { label: "No", value: "No" },
  ];
  const handleFlaggedClaimsChange = (selected) => {
    const data = Array.isArray(selected) ? selected : [];
    const flagIds = data.map(o => o.flagId);
    setsearchFields({
      ...searchFields,
      selectedFlags : flagIds ?? [],
    });
  };
  
  const handleProductChange = (selected) => {
    const selectedArray = Array.isArray(selected) ? selected : selected ? [selected] : [];
    setSelectedProducts(selectedArray);
    const lastSelected = selectedArray[selectedArray.length - 1];
    setProductID(lastSelected?.value);
    setProductName(lastSelected?.label || "");
    setsearchFields({
      ...searchFields,
      productName: lastSelected ?? "",
      claimIngestionType: lastSelected?.label !== PMFBY? "" : searchFields.claimIngestionType,
      calamityType: lastSelected?.label !== PMFBY ? "" : searchFields.calamityType,
    });
    setList([]);
  };
  return (
    <>
      {module === "claim_processing" && (
        <section className={`p-4 ${module == "claim_processing" && "ps-1"}`}>
          {/* <h2 class="heading_h2" style={{marginTop: 0}} id="search">Task Manager</h2> */}
          <div className="border rounded p-4 px-1">
            <div className="d-md-flex align-items-center justify-content-around mt-3">
              <div className="form-group w-20">
                <label for="exampleInputPassword1">Product Name</label>
                <CustomProductSelect productNames={productNames} handleProductChange={handleProductChange} selectedProducts={selectedProducts} />
              </div>
              <div className="form-group w-20">
                <label for="exampleInputPassword2">Claim Ingestion Type</label>
                <Select
                  id="exampleInputPassword2"
                  options={claimIngestionTypes}
                  placeholder="Select Claim Ingestion"
                  isDisabled={productName && productName !== PMFBY} 
                  onInputChange={(inputValue) => {
                    // Replace non-alphanumeric characters
                    const cleanedValue = inputValue.replace(/[^A-Za-z]/g, "");
                    return cleanedValue; // Return cleaned value for the Select component
                  }}
                  classNamePrefix="bg-gray"
                  value={
                    searchFields.claimIngestionType
                      ? {
                          label: titleCase(
                            searchFields.claimIngestionType.value
                          ),
                          value: searchFields.claimIngestionType.value,
                        }
                      : null
                  }
                  onChange={(data) => {
                    setsearchFields({
                      ...searchFields,
                      claimIngestionType: data ?? "",
                      calamityType :''
                    });
                  }}
                  isClearable={true}
                />
              </div>
              <div className="form-group w-23">
                <label for="exampleInputPassword3"> Calamity Type</label>
                <Select
                  id="exampleInputPassword3"
                  options={calamityTypes}
                  onInputChange={(inputValue) => {
                    // Replace non-alphanumeric characters
                    const cleanedValue = inputValue.replace(/[^A-Za-z]/g, "");
                    return cleanedValue; // Return cleaned value for the Select component
                  }}
                  classNamePrefix="bg-gray"
                  placeholder="Select Calamity Type"
                  //isDisabled={!searchFields.district}
                  isDisabled={productName && productName !== PMFBY}
                  value={
                    searchFields.calamityType
                      ? {
                          label: searchFields.calamityType.value,
                          value: searchFields.calamityType.value,
                        }
                      : null
                  }
                  onChange={(data) => {
                    setsearchFields({
                      ...searchFields,
                      calamityType: data ?? "",
                    });
                  }}
                  isClearable={true}
                />
              </div>
              <div className="form-group w-20">
                <label for="exampleInputPassword3">Claim Status</label>
                <Select
                  id="exampleInputPassword3"
                  options={claimStatus}
                  onInputChange={(inputValue) => {
                    // Replace non-alphanumeric characters
                    const cleanedValue = inputValue.replace(/[^A-Za-z]/g, "");
                    return cleanedValue; // Return cleaned value for the Select component
                  }}
                  classNamePrefix="bg-gray"
                  placeholder="Select Claim Status"
                  //isDisabled={!searchFields.district}
                  value={
                    searchFields.claimStatus
                      ? {
                          label: searchFields.claimStatus,
                          value: searchFields.claimStatus,
                        }
                      : null
                  }
                  onChange={(data) => {
                    setsearchFields({
                      ...searchFields,
                      claimStatus: data?.value ?? "",
                    });
                  }}
                  isClearable={true}
                />
              </div>
            </div>
            <div className="d-md-flex align-items-center justify-content-around mt-3">
              <div className="form-group w-20">
                <label for="exampleInputPassword1">Sub Status</label>
                <Select
                  id="exampleInputPassword1"
                  options={claimSubStatus}
                  onInputChange={(inputValue) => {
                    // Replace non-alphanumeric characters
                    const cleanedValue = inputValue.replace(/[^A-Za-z]/g, "");
                    return cleanedValue; // Return cleaned value for the Select component
                  }}
                  classNamePrefix="bg-gray"
                  placeholder="Select Sub Status"
                  //isDisabled={!searchFields.mandal}
                  value={
                    searchFields.claimSubStatus
                      ? {
                          label: searchFields.claimSubStatus,
                          value: searchFields.claimSubStatus,
                        }
                      : null
                  }
                  onChange={(data) => {
                    if (data === null) {
                      setSubStatusCount(null);
                    } else {
                      getSubStatusCount(data?.value);
                    }
                    setsearchFields({
                      ...searchFields,
                      claimSubStatus: data?.value ?? "",
                    });
                    setSelectedSubstatus(data?.value ?? "");
                  }}
                  isClearable={true}
                />
              </div>
              <div className="form-group w-20">
                <label for="exampleInputPassword2">Assigned To</label>
                <Select
                  id="exampleInputPassword2"
                  options={assignedTos}
                  classNamePrefix="bg-gray"
                  placeholder="Select Assigned To"
                  onInputChange={(inputValue) => {
                    // Replace non-alphanumeric characters
                    const cleanedValue = inputValue.replace(/[^A-Za-z]/g, "");
                    return cleanedValue; // Return cleaned value for the Select component
                  }}
                  value={
                    searchFields.assignedTo
                      ? {
                          label: searchFields.assignedTo,
                          value: searchFields.assignedTo,
                        }
                      : null
                  }
                  onChange={(data) => {
                    setsearchFields({
                      ...searchFields,
                      assignedTo: data?.value ?? "",
                    });
                  }}
                  isClearable={true}
                />

                {/* <input type="text" class="form-control bg-gray" id="exampleInputPassword1" placeholder="Enter Assigned To" onChange={(e) => { setsearchFields({ ...searchFields, 'assignedTo': e.target.value }) }} value={searchFields.assignedTo} /> */}
              </div>
              <div className="form-group w-23">
                <label for="exampleInputPassword3">Claim ID</label>
                {/* <Select id="exampleInputPassword1" options={pincodeList}
                                classNamePrefix="bg-gray" placeholder="Select claim"
                                isDisabled={!searchFields.village}
                                value={searchFields.pincode ? { label: searchFields.pincode, value: searchFields.pincode } : { label: "Select Pincode", value: "Select Pincode" }}
                            //onChange={(data) => { setsearchFields({ ...searchFields, 'pincode': data.value }) }}
                            /> */}
                <input
                  type="text"
                  className="form-control bg-gray"
                  id="exampleInputPassword3"
                  placeholder="Enter Claim ID"
                  onChange={(e) => {
                    const numericValue = e.target.value.replace(
                      /[^A-Za-z0-9]/g,
                      ""
                    ); // Replace non-alphanumeric characters
                    e.target.value = numericValue;
                    setsearchFields({
                      ...searchFields,
                      claimID: e.target.value,
                    });
                  }}
                  value={searchFields.claimID}
                />
              </div>
              <div className="form-group w-20">
                <label for="exampleInputPassword3">Policy ID</label>
                {/* <Select id="exampleInputPassword2" options={cropList}
                                classNamePrefix="bg-gray" placeholder="Select policy"
                                isDisabled={!searchFields.product_name}
                                value={searchFields.crop ? { label: searchFields.crop.label, value: searchFields.crop.value } : { label: "Select Crop", value: "Select Crop" }}
                                onChange={(data) => { setsearchFields({ ...searchFields, 'crop': data }) }}
                            /> */}
                <input
                  type="text"
                  className="form-control bg-gray"
                  id="exampleInputPassword3"
                  placeholder="Enter Policy ID"
                  onChange={(e) => {
                    const numericValue = e.target.value.replace(
                      /[^A-Za-z0-9\/]/g,
                      ""
                    ); // Replace non-alphanumeric characters
                    e.target.value = numericValue;
                    setsearchFields({
                      ...searchFields,
                      policyID: e.target.value,
                    });
                  }}
                  value={searchFields.policyID}
                />
              </div>
            </div>
            <div className="d-md-flex align-items-center justify-content-around mt-3">
              <div className="form-group w-20">
                <label htmlFor="exampleInputPassword1">Pending Actions</label>
                <Select
                  id="exampleInputPassword1"
                  options={claimPendindActions}
                  classNamePrefix="bg-gray"
                  placeholder="Select Pending Actions"
                  value={
                    searchFields.pendingActions
                      ? {
                          label: searchFields.pendingActions,
                          value: searchFields.pendingActions,
                        }
                      : null
                  }
                  onChange={(data) => {
                    setsearchFields({
                      ...searchFields,
                      pendingActions: data?.value ?? "",
                    });
                  }}
                  isClearable={true}
                />
              </div>
              <div className="form-group w-20">
                <label htmlFor="exampleInputPassword2">Policy Status</label>
                <Select
                  id="exampleInputPassword2"
                  options={policyStatusOptions}
                  classNamePrefix="bg-gray"
                  placeholder="Select Policy Status"
                  value={
                    searchFields.policyStatus
                      ? {
                          label: titleCase(searchFields.policyStatus),
                          value: searchFields.policyStatus,
                        }
                      : null
                  }
                  onChange={(data) => {
                    setsearchFields({
                      ...searchFields,
                      policyStatus: data?.value ?? "",
                    });
                  }}
                  isClearable={true}
                />
              </div>

              <div className=" w-23">
                <label htmlFor="remarkOrRequest">
                  Remarks & Request Assigned To{" "}
                </label>
                <Select
                  id="remarkOrRequest"
                  options={assigneeOptions}
                  classNamePrefix="bg-gray"
                  placeholder="Select Assigned To"
                  value={
                    searchFields.assignedTeamMemberId
                      ? {
                          label: titleCase(
                            searchFields.assignedTeamMemberId.value
                          ),
                          value: searchFields.assignedTeamMemberId.value,
                        }
                      : null
                  }
                  onChange={(data) => {
                    setsearchFields({
                      ...searchFields,
                      assignedTeamMemberId: data ?? "",
                    });
                  }}
                  isClearable={true}
                />
              </div>
              <div className="form-group w-20">
                <label htmlFor="requestEmail">Remarks and Request Email</label>
                <Select
                  id="requestEmail"
                  options={emailName}
                  classNamePrefix="bg-gray"
                  placeholder="Select Email"
                  value={
                    searchFields.email
                      ? { label: searchFields.email, value: searchFields.email }
                      : null
                  }
                  onChange={(data) => {
                    setsearchFields({
                      ...searchFields,
                      email: data?.value ?? "",
                    });
                  }}
                  onInputChange={(inputValue) => {
                    const email = inputValue;
                    getEmailName(email);
                  }}
                  noOptionsMessage={() => noOptionPlaceholder}
                  isClearable={true}
                />
              </div>
            </div>
            <div className="d-md-flex align-items-center mt-3 justify-content-around">
              <div className="form-group w-20">
                <label>Attachment Availability</label>
                <Select
                  options={attachmentAvailabilityOptions}
                  classNamePrefix="bg-gray"
                  placeholder="Attachment Availability"
                  value={
                    searchFields.isAttachmentAvailable
                      ? {
                          label: searchFields.isAttachmentAvailable,
                          value: searchFields.isAttachmentAvailable,
                        }
                      : null
                  }
                  onChange={(data) => {
                    setsearchFields({
                      ...searchFields,
                      isAttachmentAvailable: data?.value ?? "",
                    });
                  }}
                  isClearable={true}
                />
              </div>
              <div className="form-group w-20">
                <label>Flagged Claims</label>
                <CustomMultiSelect
                  label="Flagged Claims"
                  placeholder="Flagged Claims"
                  options={flaggedClaimsOptions}
                  value={flaggedClaimsOptions.filter(opt =>
                    searchFields?.selectedFlags?.includes(opt.flagId)
                  )}
                  onChange={handleFlaggedClaimsChange}
                  isMulti
                  isDisabled={false}
                  isClearable={true}
                  showCountOnly={true}                
                />
              </div>
              <div className="form-group w-23">
                <label>Claim Created By</label>
                <Select
                  options={createdByList}
                  onInputChange={(inputValue) => {
                    const cleanedValue = inputValue.replace(/[^A-Za-z]/g, "");
                    return cleanedValue;
                  }}
                  classNamePrefix="bg-gray"
                  placeholder="Select Claim Created By"
                  value={
                    searchFields.createdBy
                      ? {
                          label: searchFields.createdBy.value,
                          value: searchFields.createdBy.value,
                        }
                      : null
                  }
                  onChange={(data) => {
                    setsearchFields({
                      ...searchFields,
                      createdBy: data ?? "",
                    });
                  }}
                  isClearable={true}
                />
              </div>
              <div className="form-group w-20"></div>
            </div>
            <div>
              {isViewMore && (
                <div>
                  <div className="d-md-flex align-items-center justify-content-around mt-3">
                    <div className="form-group w-20">
                      <label for="exampleInputPassword1">Season</label>
                      <Select
                        id="exampleInputPassword1"
                        options={seasonValues}
                        classNamePrefix="bg-gray"
                        placeholder="Select Season"
                        onInputChange={(inputValue) => {
                          // Replace non-alphanumeric characters
                          const cleanedValue = inputValue.replace(
                            /[^A-Za-z]/g,
                            ""
                          );
                          return cleanedValue; // Return cleaned value for the Select component
                        }}
                        value={
                          searchFields.seasonName
                            ? {
                                label: searchFields.seasonName,
                                value: searchFields.seasonName,
                              }
                            : null
                        }
                        onChange={(data) => {
                          setsearchFields({
                            ...searchFields,
                            seasonName: data?.value ?? "",
                          });
                        }}
                        isClearable={true}
                      />
                      {/* <input type="text" class="form-control bg-gray" id="exampleInputPassword1" placeholder="Enter Assigned To" onChange={(e) => { setsearchFields({ ...searchFields, 'assignedTo': e.target.value }) }} value={searchFields.assignedTo} /> */}
                    </div>
                    <div className="form-group w-20">
                      <label for="exampleInputPassword2">Year</label>
                      <Select
                        id="exampleInputPassword2"
                        options={yearsFrom2010}
                        onInputChange={(inputValue) => {
                          // Replace non-alphanumeric characters
                          const cleanedValue = inputValue.replace(
                            /[^A-Za-z]/g,
                            ""
                          );
                          return cleanedValue; // Return cleaned value for the Select component
                        }}
                        classNamePrefix="bg-gray"
                        placeholder="Select Year"
                        value={
                          searchFields.seasonYear
                            ? {
                                label: searchFields.seasonYear,
                                value: searchFields.seasonYear,
                              }
                            : null
                        }
                        onChange={(data) => {
                          setsearchFields({
                            ...searchFields,
                            seasonYear: data?.value ?? "",
                          });
                        }}
                        isClearable={true}
                      />
                    </div>
                    <div className="form-group w-23">
                      <label for="exampleInputPassword3">Intimation Date</label>
                      <div className="d-md-flex intimation-date">
                        <div className="from-date">
                          <DatePicker
                            className="form-control bg-gray"
                            selected={
                              searchFields?.fromDate && searchFields?.fromDate
                            }
                            dateFormat="dd-MM-yy"
                            placeholderText="From date"
                            maxDate={
                              searchFields?.toDate
                                ? new Date(searchFields?.toDate)
                                : new Date()
                            }
                            onChange={(date) =>
                              handleIntimationDateRange(date, "fromDate")
                            }
                            onKeyDown={(e) => e.preventDefault()}
                            showYearDropdown
                            showMonthDropdown
                            scrollableYearDropdown
                            yearDropdownItemNumber={1000}
                          />
                          {/* <label for="exampleInputPassword3">To Date</label> */}
                        </div>
                        <div className="to-date">
                          <DatePicker
                            className="form-control bg-gray"
                            selected={
                              searchFields?.toDate && searchFields?.toDate
                            }
                            dateFormat="dd-MM-yy"
                            placeholderText="To date"
                            minDate={new Date(searchFields?.fromDate)}
                            maxDate={new Date()}
                            onChange={(date) =>
                              handleIntimationDateRange(date, "toDate")
                            }
                            onKeyDown={(e) => e.preventDefault()}
                            showYearDropdown
                            showMonthDropdown
                            scrollableYearDropdown
                            yearDropdownItemNumber={1000}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="form-group w-20">
                      <label for="exampleInputPassword3">Mobile Number</label>
                      {/* 
                            <Select id="exampleInputPassword3" options={perilList}
                                classNamePrefix="bg-gray" placeholder="Select mobile"
                                isDisabled={!searchFields.product_name}
                                value={searchFields.perilName ? { label: searchFields.perilName, value: searchFields.perilName } : { label: "Select Peril", value: "Select Peril" }}
                                onChange={(data) => { setsearchFields({ ...searchFields, 'perilName': data.value }) }}
                            /> */}
                      <input
                        type="text"
                        className="form-control bg-gray"
                        id="exampleInputPassword1"
                        placeholder="Enter Mobile Number"
                        maxLength={10}
                        minLength={10}
                        onChange={(e) => {
                          const numericValue = e.target.value.replace(
                            /[^0-9.,]/g,
                            ""
                          );
                          e.target.value = numericValue;
                          setsearchFields({
                            ...searchFields,
                            mobileNo: e.target.value,
                          });
                        }}
                        value={searchFields.mobileNo}
                      />
                    </div>
                  </div>
                  <div className="d-md-flex align-items-center justify-content-around mt-3">
                    <div className="form-group w-20">
                      <label for="exampleInputPassword1">Farmer ID</label>
                      <input
                        type="text"
                        className="form-control bg-gray"
                        id="exampleInputPassword1"
                        placeholder="Enter Farmer ID"
                        onChange={(e) => {
                          const numericValue = e.target.value.replace(
                            /[^A-Za-z0-9]/g,
                            ""
                          ); // Replace non-alphanumeric characters
                          e.target.value = numericValue;
                          setsearchFields({
                            ...searchFields,
                            farmerID: e.target.value,
                          });
                        }}
                        value={searchFields.farmerID}
                      />
                    </div>
                    <div className="form-group w-20">
                      <label for="exampleInputPassword2">Role</label>
                      <Select
                        id="exampleInputPassword2"
                        options={caimRoles}
                        onInputChange={(inputValue) => {
                          // Replace non-alphanumeric characters
                          const cleanedValue = inputValue.replace(
                            /[^A-Za-z]/g,
                            ""
                          );
                          return cleanedValue; // Return cleaned value for the Select component
                        }}
                        classNamePrefix="bg-gray"
                        placeholder="Select Role"
                        value={
                          searchFields.role
                            ? {
                                label: (searchFields.role),
                                value: searchFields.role,
                              }
                            : null
                        }
                        onChange={(data) => {
                          setsearchFields({
                            ...searchFields,
                            role: data?.value ?? "",
                          });
                        }}
                        isClearable={true}
                      />
                    </div>

                    <div className="form-group w-23">
                      <label for="exampleInputPassword3">Crop</label>
                      <Select
                        id="exampleInputPassword3"
                        options={cropOptions}
                        onInputChange={(inputValue) => {
                          // Replace non-alphanumeric characters
                          const cleanedValue = inputValue.replace(
                            /[^A-Za-z]/g,
                            ""
                          );
                          return cleanedValue; // Return cleaned value for the Select component
                        }}
                        classNamePrefix="bg-gray"
                        placeholder="Select Crop"
                        //isDisabled={!searchFields.district}
                        value={
                          searchFields.crop
                            ? {
                                label: searchFields.crop,
                                value: searchFields.crop,
                              }
                            : null
                        }
                        onChange={(data) => {
                          setsearchFields({
                            ...searchFields,
                            crop: data?.value ?? "",
                          });
                        }}
                        isClearable={true}
                      />
                    </div>
                    <div className="form-group w-20">
                      <label for="exampleInputPassword1">Peril</label>
                      <Select
                        id="exampleInputPassword1"
                        options={perilOptions}
                        onInputChange={(inputValue) => {
                          // Replace non-alphanumeric characters
                          const cleanedValue = inputValue.replace(
                            /[^A-Za-z]/g,
                            ""
                          );
                          return cleanedValue; // Return cleaned value for the Select component
                        }}
                        classNamePrefix="bg-gray"
                        placeholder="Select Peril"
                        //isDisabled={!searchFields.mandal}
                        value={
                          searchFields.peril
                            ? {
                                label: searchFields.peril,
                                value: searchFields.peril,
                              }
                            : null
                        }
                        onChange={(data) => {
                          setsearchFields({
                            ...searchFields,
                            peril: data?.value ?? "",
                          });
                        }}
                        isClearable={true}
                      />
                    </div>
                  </div>
                  <div className="d-md-flex align-items-center justify-content-around mt-3">
                    <div className="form-group w-20">
                      <label for="exampleInputPassword1">State</label>
                      <Select
                        id="exampleInputPassword1"
                        options={statesList}
                        classNamePrefix="bg-gray"
                        placeholder="Select State"
                        value={
                          searchFields.state
                            ? {
                                label: searchFields.state,
                                value: searchFields.state,
                              }
                            : null
                        }
                        onChange={(data) => {
                          if (data && data.value) {
                            getDiscrictList(data?.value);
                          }
                          setsearchFields({
                            ...searchFields,
                            state: data?.value ?? "",
                            district: "",
                            mandal: "",
                            village: "",
                          });
                        }}
                        isClearable={true}
                      />
                    </div>

                    <div className="form-group w-20">
                      <label for="exampleInputPassword2">District</label>
                      <Select
                        id="exampleInputPassword2"
                        options={districtList}
                        classNamePrefix="bg-gray"
                        placeholder="Select District"
                        isDisabled={!searchFields.state}
                        value={
                          searchFields.district
                            ? {
                                label: searchFields.district,
                                value: searchFields.district,
                              }
                            : null
                        }
                        onChange={(data) => {
                          getMandalList(data?.value);
                          setsearchFields({
                            ...searchFields,
                            district: data?.value ?? "",
                            mandal: "",
                            village: "",
                          });
                        }}
                        isClearable={true}
                      />
                    </div>
                    <div className="form-group w-23">
                      <label for="exampleInputPassword3">Mandal</label>
                      <Select
                        id="exampleInputPassword3"
                        options={mandalList}
                        classNamePrefix="bg-gray"
                        placeholder="Select Mandal"
                        isDisabled={!searchFields.district}
                        value={
                          searchFields.mandal
                            ? {
                                label: searchFields.mandal,
                                value: searchFields.mandal,
                              }
                            : null
                        }
                        onChange={(data) => {
                          getVillageList(data?.value);
                          setsearchFields({
                            ...searchFields,
                            mandal: data?.value ?? "",
                            village: "",
                          });
                        }}
                        isClearable={true}
                      />
                    </div>
                    <div className="form-group w-20">
                      <label for="exampleInputPassword1">Village</label>
                      <Select
                        id="exampleInputPassword1"
                        options={villageList}
                        classNamePrefix="bg-gray"
                        placeholder="Select Village"
                        isDisabled={!searchFields.mandal}
                        value={
                          searchFields.village
                            ? {
                                label: searchFields.village,
                                value: searchFields.village,
                              }
                            : null
                        }
                        onChange={(data) => {
                          getPincodeList(data?.value);
                          setsearchFields({
                            ...searchFields,
                            village: data?.value ?? "",
                          });
                        }}
                        isClearable={true}
                      />
                    </div>
                  </div>
                  <div className="d-md-flex align-items-center justify-content-around mt-3">
                    <div className="form-group w-20">
                      <label for="exampleInputPassword1">Vendor Name</label>
                      <Select
                        id="exampleInputPassword1"
                        options={vendorList}
                        classNamePrefix="bg-gray"
                        placeholder="Select Vendor Name"
                        onInputChange={(inputValue) => {
                          // Replace non-alphanumeric characters
                          const cleanedValue = inputValue.replace(
                            /[^A-Za-z]/g,
                            ""
                          );
                          return cleanedValue; // Return cleaned value for the Select component
                        }}
                        value={
                          searchFields.vendorName
                            ? {
                                label: searchFields.vendorName.label,
                                value: searchFields.vendorName.label,
                              }
                            : null
                        }
                        onChange={(data) => {
                          setsearchFields({
                            ...searchFields,
                            vendorName: data ?? "",
                          });
                          handleVendorChange(data ?? "");
                        }}
                        isClearable={true}
                      />
                      {/* <input type="text" class="form-control bg-gray" id="exampleInputPassword1" placeholder="Enter Assigned To" onChange={(e) => { setsearchFields({ ...searchFields, 'assignedTo': e.target.value }) }} value={searchFields.assignedTo} /> */}
                    </div>
                    <div className="form-group w-20">
                      <label for="exampleInputPassword2">Surveyor Name</label>
                      <Select
                        id="exampleInputPassword2"
                        options={surveyorList}
                        onInputChange={(inputValue) => {
                          // Replace non-alphanumeric characters
                          const cleanedValue = inputValue.replace(
                            /[^A-Za-z0-9]/g,
                            ""
                          );
                          return cleanedValue; // Return cleaned value for the Select component
                        }}
                        classNamePrefix="bg-gray"
                        placeholder="Select Surveyor Name"
                        value={
                          searchFields.surveyorName
                            ? {
                                label: titleCase(searchFields.surveyorName),
                                value: searchFields.surveyorName,
                              }
                            : null
                        }
                        onChange={(data) => {
                          setsearchFields({
                            ...searchFields,
                            surveyorName: data?.value ?? "",
                          });
                        }}
                        isDisabled={!searchFields.vendorName}
                        isClearable={true}
                      />
                    </div>

                    <div className="form-group w-23"></div>
                    {/* <div class="form-group w-20">
                            <label for="exampleInputPassword3">Alternate Mobile Number</label>
                            <input type="text" class="form-control bg-gray" id="exampleInputPassword1" placeholder="Enter Alternate Mobile Number" maxLength={10} minLength={10} onChange={(e) => {
                                const numericValue = e.target.value.replace(/[^0-9.,]/g, '');
                                e.target.value = numericValue;
                                setsearchFields({ ...searchFields, 'alternateMobileNo': e.target.value })
                            }} value={searchFields.alternateMobileNo} />
                        </div> */}
                    <div className="form-group w-20"></div>
                  </div>
                </div>
              )}
            </div>
            <div className="d-flex mx-3">
              <div className="form-group">
                <button
                  className="btn btn-success m-4 mb-0 px-4"
                  onClick={() => {
                    basicSearch("buttonClick");
                    handleScroll();
                    setList([]);
                  }}
                >
                  Search
                </button>
              </div>
              <div className="form-group">
                <div
                  className="btn btn-outline-success mt-4 mb-0 px-4"
                  onClick={() => {
                    setsearchFields({ ...searchFields, ...resetFields });
                    setList([]);
                    setSelectedProducts([])
                    setSubStatusCount(null);
                  }}
                >
                  Reset
                </div>
              </div>
              {module !== "claim_processing" && (productID !== KISAN_SATHI) && (
                <div>
                  <span
                    style={{ marginLeft: "690px", marginTop: "20px" }}
                    className="submit-1"
                    onClick={() => {
                      getClaimWithouPolicyPage();
                    }}
                  >
                    Claim Without Policy
                  </span>
                </div>
              )}
              <div
                className="d-md-flex align-items-center mt-4"
                style={{ marginLeft: "auto" }}
              >
                {subStatusCount === null ? (
                  ""
                ) : (
                  <div style={{ fontWeight: "700", marginRight: "10px" }}>
                    <span>
                      Total {selectedSubStatus} : <span>{subStatusCount}</span>
                    </span>
                  </div>
                )}
                <div
                  className="mb-0 px-4 view-more-button"
                  onClick={() => setIsViewMore(!isViewMore)}
                >
                  {isViewMore ? "- View Less" : " + View More"}
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
      {module === "claim_intimation" && (
        <section className={`p-4 ${module == "claim_intimation" && "ps-1"}`}>
          <h5>Search</h5>
          <div className="border rounded p-4 px-1">
            <div className="d-md-flex align-items-center justify-content-around mx-0 px-0">
              <div className="form-group col-md-3 ms-5">
                <label for="exampleInputPassword1">
                  Product Name <AsteriskSymbol />
                </label>
                <Select
                  id="exampleInputPassword1"
                  options={productNames}
                  onInputChange={(inputValue) => {
                    // Replace non-alphanumeric characters
                    const cleanedValue = inputValue.replace(/[^A-Za-z]/g, "");
                    return cleanedValue; // Return cleaned value for the Select component
                  }}
                  classNamePrefix="bg-gray"
                  placeholder="Select Kshema Product"
                  value={
                    searchFields.product_name.label
                      ? searchFields.product_name
                      : {
                          label: "Select Kshema Product",
                          value: "Select Kshema Product",
                        }
                  }
                  onChange={(data) => {
                    getCropsList(data.label);
                    getPerilList(data.label, setPerilList);
                    setProductID(data.value);
                    if (searchFields.search_type.value === 5) {
                      setShowAdvanceSearch(false);
                      setsearchFields({
                        ...searchFields,
                        state: "",
                        district: "",
                        mandal: "",
                        village: "",
                        pincode: "",
                        crop: "",
                        perilName: "",
                        farmer_name: "",
                        search_type: { label: "Policy ID", value: 1 },
                        search_type_value: "",
                        product_name: data,
                      });
                    } else {
                      setsearchFields({
                        ...searchFields,
                        product_name: data,
                      });
                    }
                    setList([]);
                    // setsearchFields({ ...searchFields, 'product_name': data.label})
                  }}
                />
              </div>
              <div className="form-group col-md-3 mx-3">
                <label for="exampleInputPassword2">
                  Search Type <AsteriskSymbol />
                </label>
                <Select
                  id="exampleInputPassword2"
                  options={searchTypes}
                  onInputChange={(inputValue) => {
                    // Replace non-alphanumeric characters
                    const cleanedValue = inputValue.replace(/[^A-Za-z]/g, "");
                    return cleanedValue; // Return cleaned value for the Select component
                  }}
                  isDisabled={!searchFields.product_name}
                  classNamePrefix="bg-gray"
                  placeholder="Select Search Type"
                  value={
                    searchFields.search_type.label
                      ? searchFields.search_type
                      : {
                          label: "Select Search Type",
                          value: "Select Search Type",
                        }
                  }
                  onChange={(data) => {
                    setsearchFields({
                      ...searchFields,
                      state: "",
                      district: "",
                      mandal: "",
                      village: "",
                      pincode: "",
                      crop: "",
                      perilName: "",
                      farmer_name: "",
                      search_type_value: "",
                      search_type: data,
                    });
                    data.label == "Advance Search"
                      ? setShowAdvanceSearch(true)
                      : setShowAdvanceSearch(false);
                    setList([]);
                  }}
                />
              </div>
              <div className="form-group col-md-3 mx-3">
                {searchFields.search_type.label !== "Advance Search" && (
                  <>
                    <label for="exampleInputPassword3">
                      {searchFields.search_type.label}
                    </label>
                    <span className="text-danger">*</span>
                    <input
                      type="text"
                      className="form-control bg-gray"
                      id="exampleInputPassword3"
                      placeholder={`Enter ${searchFields.search_type.label}`}
                      maxLength={
                        searchFields.search_type.value == 2
                          ? 10
                          : searchFields.search_type.value == 1
                          ? 50
                          : ""
                      }
                      minLength={searchFields.search_type.value == 2 ? 10 : ""}
                      onChange={(e) => {
                        if (
                          searchFields.search_type.value == 2 ||
                          searchFields.search_type.value == 1
                        ) {
                          if (/[^A-Za-z\d\/]/.test(e.target.value)) {
                            return;
                          }
                        }
                        if (searchFields.search_type.value == 2) {
                          const numericValue = e.target.value.replace(
                            /[^0-9.,]/g,
                            ""
                          );
                          e.target.value = numericValue;
                          setsearchFields({
                            ...searchFields,
                            search_type_value: e.target.value,
                          });
                        } else {
                          const numericValue = e.target.value.replace(
                            /[^A-Za-z0-9\/]/g,
                            ""
                          ); // Replace non-alphanumeric characters
                          e.target.value = numericValue;
                          setsearchFields({
                            ...searchFields,
                            search_type_value: e.target.value,
                          });
                        }
                      }}
                      value={searchFields.search_type_value}
                      // Additional attributes to prevent autofill
                      name="mobile-number"
                      autoComplete="mobile-number-new"
                      data-autofill-type="mobile-number"
                    />
                  </>
                )}
              </div>
              <div className="form-group col-md-3 mx-3">
                {searchFields.search_type.label !== "Advance Search" && (
                  <button
                    className="btn btn-success m-3 ms-0 mb-0 px-4"
                    disabled={
                      !searchFields.search_type_value &&
                      !searchFields.product_name
                    }
                    onClick={() => basicSearch()}
                  >
                    Search
                  </button>
                )}
              </div>
            </div>
          </div>
        </section>
      )}
      {module === "vendor_master" && (
        <section className={`p-4 ${module == "vendor_master" && "ps-1"}`}>
          <div className="row">
            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-xs-12">
              <label>Vendor ID</label>
              <input
                type="text"
                id="vendor_name"
                placeholder="Vendor ID"
                className="selectMasters"
                value={searchFields.vendorId}
                onChange={(e) => {
                  const numericValue = e.target.value.replace(/[^0-9.,]/g, "");
                  e.target.value = numericValue;
                  setsearchFields({
                    ...searchFields,
                    vendorId: e.target.value,
                  });
                }}
              />
            </div>
            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-xs-12">
              <label>Vendor Name</label>
              <input
                type="text"
                id="vendor_name"
                placeholder="Vendor Name"
                className="selectMasters"
                value={searchFields.vendorName}
                onChange={(e) =>
                  setsearchFields({
                    ...searchFields,
                    vendorName: e.target.value,
                  })
                }
              />
            </div>
            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-xs-12">
              <label>Mobile Number</label>
              <input
                type="text"
                id="vendor_name"
                placeholder="Mobile Number"
                className="selectMasters"
                maxLength={10}
                value={searchFields.mobileNumber}
                onChange={(e) => {
                  const numericValue = e.target.value.replace(/[^0-9.,]/g, "");
                  e.target.value = numericValue;
                  setsearchFields({
                    ...searchFields,
                    mobileNumber: e.target.value,
                  });
                }}
              />
            </div>
            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-xs-12">
              <label>Email</label>
              <input
                type="text"
                id="vendor_name"
                placeholder="Email"
                className="selectMasters"
                value={searchFields.email}
                onChange={(e) =>
                  setsearchFields({ ...searchFields, email: e.target.value })
                }
              />
            </div>
            <div className="row" style={{ marginLeft: "-1rem" }}>
              <div className="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-xs-12 ms-2">
                <div className="form-group">
                  <label for="exampleInputPassword1">State</label>
                  <Select
                    id="exampleInputPassword1"
                    options={statesList}
                    classNamePrefix="bg-gray"
                    placeholder="Select State"
                    value={
                      searchFields.state
                        ? {
                            label: searchFields.state,
                            value: searchFields.state,
                          }
                        : null
                    }
                    onChange={(data) => {
                      getDiscrictList(data?.value);
                      setsearchFields({
                        ...searchFields,
                        state: data?.value ?? "",
                        district: "",
                      });
                    }}
                    isClearable={true}
                  />
                </div>
              </div>
              <div className="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-xs-12 ms-2">
                <div className="form-group">
                  <label for="exampleInputPassword2">District</label>
                  <Select
                    id="exampleInputPassword2"
                    options={districtList}
                    classNamePrefix="bg-gray"
                    placeholder="Select District"
                    isDisabled={!searchFields.state}
                    value={
                      searchFields.district
                        ? {
                            label: searchFields.district,
                            value: searchFields.district,
                          }
                        : null
                    }
                    onChange={(data) => {
                      getMandalList(data?.value);
                      setsearchFields({
                        ...searchFields,
                        district: data?.value ?? "",
                      });
                    }}
                    isClearable={true}
                  />
                </div>
              </div>
              <div className="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-xs-12 ms-2">
                <div className="form-group">
                  <label for="exampleInputPassword2">Status</label>
                  <Select
                    id="exampleInputPassword2"
                    options={cmsStatusListCookies.map((list) => {
                      return {
                        label: firstLetterCapital(list.name),
                        value: list.id,
                      };
                    })}
                    classNamePrefix="bg-gray"
                    placeholder="Select Status"
                    value={
                      searchFields?.status
                        ? { label: searchFields.status.label }
                        : null
                    }
                    onChange={(data) => {
                      setsearchFields({
                        ...searchFields,
                        status: data ?? "",
                      });
                    }}
                    isClearable={true}
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="form-group">
                <button
                  className="btn btn-success m-1 mb-0 px-4 mt-4"
                  onClick={() => basicSearch()}
                >
                  Search
                </button>
                <button
                  className="btn btn-outline-success m-5 mb-0 px-4 mt-4"
                  onClick={() => {
                    setsearchFields({ ...searchFields, ...resetFields });
                    setList([]);
                  }}
                >
                  Reset
                </button>
                {editModeOn(functionalities.VENDOR_MASTER_TAB) && (
                  <button
                    className="btn btn-outline-success m-1 mb-0 px-4 mt-4 mr-4"
                    style={{ paddingRight: "20%" }}
                    onClick={() => {
                      localStorage.removeItem("id");
                      navigate(
                        `/dashboard/${PAGE_NAME_KEYS.VENDOR_MASTER}/${PAGE_NAME_KEYS.VENDOR_MASTER_CREATION}`
                      );
                    }}
                  >
                    Create
                  </button>
                )}
              </div>
            </div>
            {}
            {list.length > 0 && (
              <Col xs={11}>
                <h2 className="heading_h2">Search Results</h2>
              </Col>
            )}
          </div>
        </section>
      )}
      {module === "surveyor_master" && (
        <section className={`p-4 ${module == "surveyor_master" && "ps-1"}`}>
          <div className="row">
            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-xs-12">
              <label>Surveyor/QC ID</label>
              <input
                type="text"
                id="vendor_name"
                placeholder="Surveyor/QC ID"
                className="selectMasters"
                value={searchFields.surveyorId}
                onChange={(e) => {
                  const numericValue = e.target.value.replace(/[^0-9.,]/g, "");
                  e.target.value = numericValue;
                  setsearchFields({
                    ...searchFields,
                    surveyorId: e.target.value,
                  });
                }}
              />
            </div>
            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-xs-12">
              <label>First Name</label>
              <input
                type="text"
                id="vendor_name"
                placeholder="First Name"
                className="selectMasters"
                value={searchFields.firstName}
                onChange={(e) =>
                  setsearchFields({
                    ...searchFields,
                    firstName: e.target.value,
                  })
                }
              />
            </div>
            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-xs-12">
              <label>Last Name</label>
              <input
                type="text"
                id="vendor_name"
                placeholder="Last Name"
                className="selectMasters"
                value={searchFields.lastName}
                onChange={(e) =>
                  setsearchFields({ ...searchFields, lastName: e.target.value })
                }
              />
            </div>
            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-xs-12">
              <label>Mobile Number</label>
              <input
                type="text"
                id="vendor_name"
                placeholder="Mobile Number"
                className="selectMasters"
                maxLength={10}
                value={searchFields.mobileNumber}
                onChange={(e) => {
                  const numericValue = e.target.value.replace(/[^0-9.,]/g, "");
                  e.target.value = numericValue;
                  setsearchFields({
                    ...searchFields,
                    mobileNumber: e.target.value,
                  });
                }}
              />
            </div>
            <div className="row">
              <div className="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-xs-12">
                <label>Email</label>
                <input
                  type="text"
                  id="vendor_name"
                  placeholder="Email"
                  className="selectMasters"
                  value={searchFields.email}
                  onChange={(e) =>
                    setsearchFields({ ...searchFields, email: e.target.value })
                  }
                />
              </div>
              <div className="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-xs-12">
                <label for="exampleInputPassword1">State</label>
                <Select
                  id="exampleInputPassword1"
                  options={statesList}
                  classNamePrefix="bg-gray"
                  placeholder="Select State"
                  value={
                    searchFields.state
                      ? { label: searchFields.state, value: searchFields.state }
                      : null
                  }
                  onChange={(data) => {
                    getDiscrictList(data?.value);
                    setsearchFields({
                      ...searchFields,
                      state: data?.value ?? "",
                      district: "",
                    });
                  }}
                  isClearable={true}
                />
              </div>
              <div className="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-xs-12">
                <label for="exampleInputPassword2">District</label>
                <Select
                  id="exampleInputPassword2"
                  options={districtList}
                  classNamePrefix="bg-gray"
                  placeholder="Select District"
                  isDisabled={!searchFields.state}
                  value={
                    searchFields.district
                      ? {
                          label: searchFields.district,
                          value: searchFields.district,
                        }
                      : null
                  }
                  onChange={(data) => {
                    getMandalList(data?.value);
                    setsearchFields({
                      ...searchFields,
                      district: data?.value ?? "",
                    });
                  }}
                  isClearable={true}
                />
              </div>
              <div className="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-xs-12">
                <label for="exampleInputPassword2">Status</label>
                <Select
                  id="exampleInputPassword2"
                  options={cmsStatusListCookies.map((list) => {
                    return {
                      label: firstLetterCapital(list.name),
                      value: list.id,
                    };
                  })}
                  classNamePrefix="bg-gray"
                  placeholder="Select Status"
                  value={
                    searchFields?.status
                      ? { label: searchFields.status.label }
                      : null
                  }
                  onChange={(data) => {
                    setsearchFields({
                      ...searchFields,
                      status: data ?? "",
                    });
                  }}
                  isClearable={true}
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="form-group">
              <button
                className="btn btn-success m-1 mb-0 px-4 mt-4"
                onClick={() => basicSearch()}
              >
                Search
              </button>
              <button
                className="btn btn-outline-success m-5 mb-0 px-4 mt-4"
                onClick={() => {
                  setsearchFields({ ...searchFields, ...resetFields });
                  setList([]);
                }}
              >
                Reset
              </button>
              {editModeOn(functionalities.SURVEYOR_MASTER_TAB) && (
                <button
                  className="btn btn-outline-success m-1 mb-0 px-4 mt-4 mr-4"
                  style={{ paddingRight: "20%" }}
                  onClick={() => {
                    localStorage.removeItem("SurveyorId");
                    navigate(
                      `/dashboard/${PAGE_NAME_KEYS.SURVEYOR_MASTER}/${PAGE_NAME_KEYS.SURVEYOR_MASTER_CREATION}`
                    );
                  }}
                >
                  Create
                </button>
              )}
            </div>
          </div>
          {}
          {list.length > 0 && (
            <Col xs={11}>
              <h2 className="heading_h2">Search Results</h2>
            </Col>
          )}
        </section>
      )}
      {showAdvanceSearch && (
        <section className="p-4">
          <div className="border rounded p-4 px-1">
            <h5 className="ms-4">Advance Search</h5>
            <div className="d-md-flex align-items-center justify-content-around mt-3">
              <div className="form-group w-20">
                <label for="exampleInputPassword1">
                  State <AsteriskSymbol />
                </label>
                <Select
                  id="exampleInputPassword1"
                  options={statesList}
                  classNamePrefix="bg-gray"
                  placeholder="Select State"
                  value={
                    searchFields.state
                      ? { label: searchFields.state, value: searchFields.state }
                      : { label: "Select State", value: "Select State" }
                  }
                  onChange={(data) => {
                    getDiscrictList(data.value);
                    setsearchFields({
                      ...searchFields,
                      state: data.value,
                      district: "",
                      mandal: "",
                      village: "",
                      pincode: "",
                    });
                  }}
                />
              </div>
              <div className="form-group w-20">
                <label for="exampleInputPassword2">
                  District <AsteriskSymbol />
                </label>
                <Select
                  id="exampleInputPassword2"
                  options={districtList}
                  classNamePrefix="bg-gray"
                  placeholder="Select District"
                  isDisabled={!searchFields.state}
                  value={
                    searchFields.district
                      ? {
                          label: searchFields.district,
                          value: searchFields.district,
                        }
                      : { label: "Select District", value: "Select District" }
                  }
                  onChange={(data) => {
                    getMandalList(data.value);
                    setsearchFields({
                      ...searchFields,
                      district: data.value,
                      mandal: "",
                      village: "",
                      pincode: "",
                    });
                  }}
                />
              </div>
              <div className="form-group w-20">
                <label for="exampleInputPassword3">
                  Mandal <AsteriskSymbol />
                </label>
                <Select
                  id="exampleInputPassword3"
                  options={mandalList}
                  classNamePrefix="bg-gray"
                  placeholder="Select Mandal"
                  isDisabled={!searchFields.district}
                  value={
                    searchFields.mandal
                      ? {
                          label: searchFields.mandal,
                          value: searchFields.mandal,
                        }
                      : { label: "Select Mandal", value: "Select Mandal" }
                  }
                  onChange={(data) => {
                    getVillageList(data.value);
                    setsearchFields({
                      ...searchFields,
                      mandal: data.value,
                      village: "",
                      pincode: "",
                    });
                  }}
                />
              </div>
              <div className="form-group w-20">
                <label for="exampleInputPassword1">
                  Village <AsteriskSymbol />
                </label>
                <Select
                  id="exampleInputPassword1"
                  options={villageList}
                  classNamePrefix="bg-gray"
                  placeholder="Select Village"
                  isDisabled={!searchFields.mandal}
                  value={
                    searchFields.village
                      ? {
                          label: searchFields.village,
                          value: searchFields.village,
                        }
                      : { label: "Select Village", value: "Select Village" }
                  }
                  onChange={(data) => {
                    getPincodeList(data.value);
                    setsearchFields({
                      ...searchFields,
                      village: data.value,
                      pincode: "",
                    });
                  }}
                />
              </div>
            </div>
            <div className="d-md-flex align-items-center justify-content-around mt-4">
              <div className="form-group w-20">
                <label for="exampleInputPassword1">Pincode</label>
                <Select
                  id="exampleInputPassword1"
                  options={pincodeList}
                  classNamePrefix="bg-gray"
                  placeholder="Select Pincode"
                  isDisabled={!searchFields.village}
                  value={
                    searchFields.pincode
                      ? {
                          label: searchFields.pincode,
                          value: searchFields.pincode,
                        }
                      : { label: "Select Pincode", value: "Select Pincode" }
                  }
                  //onChange={(data) => { setsearchFields({ ...searchFields, 'pincode': data.value }) }}
                />
              </div>
              <div className="form-group w-20">
                <label for="exampleInputPassword2">Crop </label>
                <Select
                  id="exampleInputPassword2"
                  options={cropList}
                  classNamePrefix="bg-gray"
                  placeholder="Select Crop"
                  isDisabled={!searchFields.product_name}
                  value={
                    searchFields.crop
                      ? {
                          label: searchFields.crop.label,
                          value: searchFields.crop.value,
                        }
                      : null
                  }
                  onChange={(data) => {
                    setsearchFields({ ...searchFields, crop: data });
                  }}
                  isClearable={true}
                />
              </div>
              <div className="form-group w-20">
                <label for="exampleInputPassword3">Peril</label>
                <Select
                  id="exampleInputPassword3"
                  options={perilList}
                  classNamePrefix="bg-gray"
                  placeholder="Select Peril"
                  isDisabled={!searchFields.product_name}
                  value={
                    searchFields.perilName
                      ? {
                          label: searchFields.perilName,
                          value: searchFields.perilName,
                        }
                      : null
                  }
                  onChange={(data) => {
                    setsearchFields({
                      ...searchFields,
                      perilName: data?.value,
                    });
                  }}
                  isClearable={true}
                />
              </div>
              <div className="form-group w-20">
                <label for="exampleInputPassword1">Farmer Name</label>
                <input
                  type="text"
                  className="form-control bg-gray"
                  id="exampleInputPassword1"
                  disabled={!searchFields.state}
                  placeholder="Enter Farmer Name"
                  onChange={(e) => {
                    setsearchFields({
                      ...searchFields,
                      farmer_name: e.target.value,
                    });
                  }}
                  value={searchFields.farmer_name}
                />
              </div>
            </div>
            <div className="d-flex ms-3 justify-content-between">
              <div className="d-flex">
                <div className="form-group">
                  <button
                    className="btn btn-success m-4 mb-0 px-4"
                    onClick={() => advanceSearch()}
                  >
                    Search
                  </button>
                </div>
                <div className="form-group">
                  <div
                    className="btn btn-outline-success mt-4 mb-0 px-4"
                    onClick={() => {
                      setsearchFields({ ...searchFields, ...resetFields });
                      setList([]);
                    }}
                  >
                    Reset
                  </div>
                </div>
              </div>
              {module !== "claim_processing" &&
              editModeOn(functionalities.CLAIM_CREATION) && (productID !== KISAN_SATHI) && (
                <div>
                  <span
                    style={{
                      marginRight: "40px",
                      marginTop: "20px",
                      color: isGovtProduct ? "gray" : "white",
                      cursor: isGovtProduct ? "not-allowed" : "pointer",
                      pointerEvents: isGovtProduct ? "none" : "auto",
                    }}
                    className="submit-1"
                    onClick={() => {
                      if (!isGovtProduct) {
                        getClaimWithouPolicyPage();
                      }
                    }}
                  >
                    Claim Without Policy
                  </span>
                </div>
              )}
            </div>
          </div>
        </section>
      )}
    </>
  );
};

export default AdvanceSearch;
